const action = 'ORGANIZATIONS_MEMBERS';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { orgId }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: { members, invitations, workspaces, allowedDomains }
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
